import {
	createStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations
import {
	BreakpointWidth
} from '@app/enumerations';

const styles = (theme: Theme) => {

	return createStyles({
		formStatusMessageLabel_statusWrapper: {
			display: 'flex',
		},
		formStatusMessageLabel_statusIconWrapper: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			marginRight: theme.spacing(1),
		},
		formStatusMessageLabel_statusIconPrimary: {
			color: theme.palette.primary.main,
		},
		formStatusMessageLabel_statusIconSecondary: {
			color: theme.palette.secondary.main,
		},
		formStatusMessageLabel_statusIconWarning: {
			color: theme.palette.warning.main,
		},
		formStatusMessageLabel_statusIconError: {
			color: theme.palette.error.main,
		},
		formStatusMessageLabel_statusIconSuccess: {
			color: theme.palette.success.main,
		},
		formStatusMessageLabel_statusIconInfo: {
			color: theme.palette.info.main,
		},
		formStatusMessageLabel_statusLabelWrapper: {
			display: 'flex',
			justifyContent: 'space-between',
			width: '100%',
		},
		formStatusMessageLabel_statusLabel: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			fontSize: theme.typography.subtitle1.fontSize,
		},
		formStatusMessageLabel_statusLabelPrimary: {
			color: theme.palette.primary.main,
		},
		formStatusMessageLabel_statusLabelSecondary: {
			color: theme.palette.secondary.main,
		},
		formStatusMessageLabel_statusLabelWarning: {
			color: theme.palette.warning.main,
		},
		formStatusMessageLabel_statusLabelError: {
			color: theme.palette.error.main,
		},
		formStatusMessageLabel_statusLabelSuccess: {
			color: theme.palette.success.main,
		},
		formStatusMessageLabel_statusLabelInfo: {
			color: theme.palette.info.main,
		},
	});
}

export default styles;
